export default __webpack_public_path__ + "static/media/015-witch hat.31b6880a.svg";